import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/ebay-offer-to-buyers';

export default function Example() {
  return (
    <>
      <Head>
        <title>Selling on eBay? Here Are Effective Tips On Making Offers To Buyers</title>
        <meta
          name='description'
          content='Start closing sales fast and getting the best deal out of your listings through offers to buyers–and here are the easy, convenient ways you can do it.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/ebay-offer-to-buyers' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/ebay-offer-to-buyers' />
        <meta property='og:title' content='Selling on eBay? Here Are Effective Tips On Making Offers To Buyers' />
        <meta
          property='og:description'
          content='Start closing sales fast and getting the best deal out of your listings through offers to buyers–and here are the easy, convenient ways you can do it.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='March 29th, 2022' />
        <meta property='article:modified_time' content='March 29th, 2022' />
        <meta property='article:tag' content='eBay' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
